/**
 * The durations the app's chrome moves at, so motions that run together line up. They are the
 * values the codebase already converges on: 150ms for a fade or a content swap, 200ms for a panel
 * or a width, 300ms for a larger reveal. Use the class for a Tailwind transition and the number
 * for the timers that wait on one.
 */
export const MOTION_DURATION_MS = {
  short: 150,
  medium: 200,
  long: 300,
} as const;

export const MOTION_DURATION_CLASS = {
  short: "duration-150",
  medium: "duration-200",
  long: "duration-300",
} as const;
